var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoActiveSessions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 221,
    viewBox: "0 0 223 221",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157.993 35.7427H137.63V220.531H157.993V35.7427Z",
    fill: "#6C757D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M157.993 35.7427H154.465V220.531H157.993V35.7427Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M149.782 64.6975H76.9453V220.531H149.782V64.6975Z",
    fill: "#263238"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M149.782 64.6975H76.9453V220.531H149.782V64.6975Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6327 35.7427H68.2703V220.531H88.6327V35.7427Z",
    fill: "#6C757D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M88.6431 35.7427H85.1152V220.531H88.6431V35.7427Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M161.552 0H65.1243V39.3322H161.552V0Z",
    fill: "#6C757D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M161.552 0H65.1243V39.3322H161.552V0Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M161.552 0H86.8792V39.3322H161.552V0Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M145.46 73.053H95.6885V220.531H145.46V73.053Z",
    fill: "#6C757D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M145.46 73.053H95.6885V220.531H145.46V73.053Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M139.858 80.8926H103.796V106.041H139.858V80.8926Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4825 90.8469H72.4068C71.4497 90.8469 70.6738 91.6228 70.6738 92.5799V135.935C70.6738 136.892 71.4497 137.668 72.4068 137.668H78.4825C79.4396 137.668 80.2155 136.892 80.2155 135.935V92.5799C80.2155 91.6228 79.4396 90.8469 78.4825 90.8469Z",
    fill: "#263238"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M78.4825 90.8469H72.4068C71.4497 90.8469 70.6738 91.6228 70.6738 92.5799V135.935C70.6738 136.892 71.4497 137.668 72.4068 137.668H78.4825C79.4396 137.668 80.2155 136.892 80.2155 135.935V92.5799C80.2155 91.6228 79.4396 90.8469 78.4825 90.8469Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3146 131.912H75.1094C75.2579 131.912 75.405 131.883 75.5421 131.825C75.6792 131.768 75.8036 131.685 75.9081 131.579C76.0127 131.474 76.0953 131.348 76.1512 131.211C76.2071 131.073 76.2351 130.926 76.2338 130.777V122.793C76.2338 122.492 76.3533 122.204 76.5661 121.991C76.7789 121.778 77.0675 121.659 77.3685 121.659C77.5161 121.659 77.6623 121.629 77.7987 121.573C77.9352 121.516 78.0591 121.434 78.1635 121.329C78.2679 121.225 78.3507 121.101 78.4072 120.964C78.4637 120.828 78.4928 120.682 78.4928 120.534V93.7145C78.4928 93.5668 78.4637 93.4206 78.4072 93.2842C78.3507 93.1478 78.2679 93.0238 78.1635 92.9194C78.0591 92.815 77.9352 92.7322 77.7987 92.6757C77.6623 92.6192 77.5161 92.5901 77.3685 92.5901H73.3558C73.0576 92.5901 72.7716 92.7085 72.5608 92.9194C72.3499 93.1303 72.2314 93.4163 72.2314 93.7145V130.788C72.2312 131.079 72.344 131.359 72.546 131.568C72.7481 131.778 73.0236 131.901 73.3146 131.912Z",
    fill: "#263238"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7907 141.32H74.5214C73.6041 141.32 72.8606 142.063 72.8606 142.98V147.292C72.8606 148.209 73.6041 148.953 74.5214 148.953H76.7907C77.7079 148.953 78.4515 148.209 78.4515 147.292V142.98C78.4515 142.063 77.7079 141.32 76.7907 141.32Z",
    fill: "#263238"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M76.7907 141.32H74.5214C73.6041 141.32 72.8606 142.063 72.8606 142.98V147.292C72.8606 148.209 73.6041 148.953 74.5214 148.953H76.7907C77.7079 148.953 78.4515 148.209 78.4515 147.292V142.98C78.4515 142.063 77.7079 141.32 76.7907 141.32Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7126 213.362C64.7929 213.348 62.9564 212.576 61.6037 211.214C60.251 209.851 59.4919 208.009 59.4919 206.089V132.696C59.5231 132.322 59.6936 131.974 59.9697 131.72C60.2458 131.465 60.6073 131.324 60.9825 131.324C61.3577 131.324 61.7192 131.465 61.9953 131.72C62.2714 131.974 62.4419 132.322 62.4731 132.696V206.089C62.4731 207.227 62.9252 208.319 63.7299 209.124C64.5347 209.928 65.6261 210.381 66.7642 210.381C67.9023 210.381 68.9938 209.928 69.7985 209.124C70.6033 208.319 71.0554 207.227 71.0554 206.089V147.674C71.0581 146.528 71.5144 145.431 72.3243 144.621C73.1343 143.811 74.232 143.354 75.3775 143.352C75.7514 143.383 76.1 143.553 76.354 143.83C76.6081 144.106 76.7491 144.467 76.7491 144.842C76.7491 145.218 76.6081 145.579 76.354 145.855C76.1 146.131 75.7514 146.302 75.3775 146.333C75.0209 146.333 74.6787 146.474 74.4256 146.725C74.1725 146.976 74.0289 147.317 74.0262 147.674V206.089C74.0262 207.048 73.8368 207.997 73.4687 208.882C73.1007 209.767 72.5613 210.57 71.8816 211.246C71.202 211.922 70.3954 212.457 69.5083 212.82C68.6212 213.183 67.6711 213.367 66.7126 213.362Z",
    fill: "#263238"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8103 94.9419L67.4143 103.07C66.6216 103.933 66.0049 104.942 65.5988 106.041L62.9478 113.117L65.5472 113.448L67.8063 107.423C68.2061 106.362 68.7969 105.383 69.5495 104.535L76.3061 96.9637C76.5262 96.8141 76.6943 96.5995 76.7867 96.3499C76.8792 96.1003 76.8915 95.828 76.8218 95.5711C76.7567 95.3759 76.6461 95.199 76.4992 95.0549C76.3524 94.9107 76.1734 94.8036 75.977 94.7421C75.7806 94.6807 75.5724 94.6668 75.3696 94.7015C75.1668 94.7362 74.9751 94.8186 74.8103 94.9419Z",
    fill: "#263238"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M74.8103 94.9419L67.4143 103.07C66.6216 103.933 66.0049 104.942 65.5988 106.041L62.9478 113.117L65.5472 113.448L67.8063 107.423C68.2061 106.362 68.7969 105.383 69.5495 104.535L76.3061 96.9637C76.5262 96.8141 76.6943 96.5995 76.7867 96.3499C76.8792 96.1003 76.8915 95.828 76.8218 95.5711C76.7567 95.3759 76.6461 95.199 76.4992 95.0549C76.3524 94.9107 76.1734 94.8036 75.977 94.7421C75.7806 94.6807 75.5724 94.6668 75.3696 94.7015C75.1668 94.7362 74.9751 94.8186 74.8103 94.9419Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4433 109.26L66.9499 109.641C67.1351 109.667 67.3108 109.739 67.4605 109.851C67.6103 109.962 67.7292 110.111 67.8061 110.281L70.9006 116.996C71.2085 117.667 71.2527 118.429 71.0244 119.131L68.0021 128.415C67.9196 128.668 67.7498 128.884 67.5232 129.024C67.2965 129.164 67.0275 129.219 66.7642 129.179L59.1 128.023C58.9233 127.993 58.7559 127.922 58.611 127.817C58.4661 127.711 58.3475 127.574 58.2644 127.415L57.7177 126.383C57.5899 126.118 57.5167 125.829 57.5025 125.535C57.4884 125.241 57.5335 124.947 57.6352 124.671L63.2776 110.033C63.356 109.792 63.5138 109.584 63.7255 109.443C63.9372 109.303 64.1902 109.238 64.4433 109.26Z",
    fill: "#6C757D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M64.4433 109.26L66.9499 109.641C67.1351 109.667 67.3108 109.739 67.4605 109.851C67.6103 109.962 67.7292 110.111 67.8061 110.281L70.9006 116.996C71.2085 117.667 71.2527 118.429 71.0244 119.131L68.0021 128.415C67.9196 128.668 67.7498 128.884 67.5232 129.024C67.2965 129.164 67.0275 129.219 66.7642 129.179L59.1 128.023C58.9233 127.993 58.7559 127.922 58.611 127.817C58.4661 127.711 58.3475 127.574 58.2644 127.415L57.7177 126.383C57.5899 126.118 57.5167 125.829 57.5025 125.535C57.4884 125.241 57.5335 124.947 57.6352 124.671L63.2776 110.033C63.356 109.792 63.5138 109.584 63.7255 109.443C63.9372 109.303 64.1902 109.238 64.4433 109.26Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6365 126.497L62.1018 126.868C62.1707 126.881 62.2369 126.905 62.2978 126.94L65.5781 128.725C65.6557 128.767 65.7226 128.827 65.774 128.899C65.8253 128.971 65.8597 129.054 65.8746 129.141C65.8895 129.228 65.8844 129.318 65.8599 129.403C65.8353 129.488 65.7919 129.566 65.7328 129.632L62.8858 132.882C62.7976 132.987 62.684 133.067 62.5558 133.116C62.4276 133.165 62.2891 133.18 62.1534 133.16L59.9356 132.82C59.751 132.794 59.5812 132.704 59.4551 132.567C59.3291 132.43 59.2546 132.253 59.2445 132.067L58.9557 127.115C58.9518 127.028 58.9673 126.94 59.001 126.859C59.0348 126.778 59.0859 126.705 59.1509 126.646C59.2159 126.587 59.2931 126.543 59.377 126.517C59.4609 126.491 59.5495 126.484 59.6365 126.497Z",
    fill: "#263238"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M59.6365 126.497L62.1018 126.868C62.1707 126.881 62.2369 126.905 62.2978 126.94L65.5781 128.725C65.6557 128.767 65.7226 128.827 65.774 128.899C65.8253 128.971 65.8597 129.054 65.8746 129.141C65.8895 129.228 65.8844 129.318 65.8599 129.403C65.8353 129.488 65.7919 129.566 65.7328 129.632L62.8858 132.882C62.7976 132.987 62.684 133.067 62.5558 133.116C62.4276 133.165 62.2891 133.18 62.1534 133.16L59.9356 132.82C59.751 132.794 59.5812 132.704 59.4551 132.567C59.3291 132.43 59.2546 132.253 59.2445 132.067L58.9557 127.115C58.9518 127.028 58.9673 126.94 59.001 126.859C59.0348 126.778 59.0859 126.705 59.1509 126.646C59.2159 126.587 59.2931 126.543 59.377 126.517C59.4609 126.491 59.5495 126.484 59.6365 126.497Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M139.858 108.754H103.796V129.756H139.858V108.754Z",
    fill: "#263238"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M139.858 108.754H103.796V129.756H139.858V108.754Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M108.263 110.941H106.447V112.757H108.263V110.941Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M111.11 110.941H109.294V112.757H111.11V110.941Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M113.957 110.941H112.141V112.757H113.957V110.941Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M108.263 113.685H106.447V115.501H108.263V113.685Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M111.11 113.685H109.294V115.501H111.11V113.685Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M113.957 113.685H112.141V115.501H113.957V113.685Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M108.263 116.429H106.447V118.244H108.263V116.429Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M111.11 116.429H109.294V118.244H111.11V116.429Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M113.957 116.429H112.141V118.244H113.957V116.429Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M108.263 119.173H106.447V120.988H108.263V119.173Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M111.11 119.173H109.294V120.988H111.11V119.173Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M113.957 119.173H112.141V120.988H113.957V119.173Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M117.722 110.941H114.916V112.757H117.722V110.941Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M117.722 113.685H114.916V115.501H117.722V113.685Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M117.722 116.429H114.916V118.244H117.722V116.429Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M110.522 121.917H109.294H106.447V123.722H109.294H110.522H111.11V121.917H110.522Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M113.957 121.917H112.141V123.732H113.957V121.917Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M114.916 119.173V121.916V122.401V123.722H117.722V122.401V121.916V119.173H114.916Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M128.202 110.941H126.387V112.757H128.202V110.941Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M131.049 110.941H129.234V112.757H131.049V110.941Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M133.907 110.941H132.091V112.757H133.907V110.941Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M128.202 113.685H126.387V115.501H128.202V113.685Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M131.049 113.685H129.234V115.501H131.049V113.685Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M133.907 113.685H132.091V115.501H133.907V113.685Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M128.202 116.429H126.387V118.244H128.202V116.429Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M131.049 116.429H129.234V118.244H131.049V116.429Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M133.907 116.429H132.091V118.244H133.907V116.429Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M128.202 119.173H126.387V120.988H128.202V119.173Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M131.049 119.173H129.234V120.988H131.049V119.173Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M133.907 119.173H132.091V120.988H133.907V119.173Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M137.671 110.941H134.866V112.757H137.671V110.941Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M137.671 113.685H134.866V115.501H137.671V113.685Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M137.671 116.429H134.866V118.244H137.671V116.429Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M130.472 121.917H129.234H126.387V123.722H129.234H130.472H131.049V121.917H130.472Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M133.907 121.917H132.091V123.732H133.907V121.917Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M134.866 119.173V121.916V122.401V123.722H137.671V122.401V121.916V119.173H134.866Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M124.365 110.941H119.661V115.057H124.365V110.941Z",
    fill: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M124.365 116.429H119.661V120.545H124.365V116.429Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M117.722 124.784H106.427V128.126H117.722V124.784Z",
    fill: "black"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M137.682 124.784H126.387V128.126H137.682V124.784Z",
    fill: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M139.858 130.52H103.796V220.531H139.858V130.52Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M136.269 82.9146H103.796V104.474H136.269V82.9146Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M139.848 80.8926L136.269 82.9144V104.473L139.848 106.041V80.8926Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M97.5143 73.053H95.6885V220.531H97.5143V73.053Z",
    fill: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M104.714 4.25V17.8352H91.1187L104.714 4.25Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1187 4.25V17.8352L104.714 4.25H91.1187Z",
    fill: "#6C757D"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M91.1187 17.8352H104.714L91.1187 4.25V17.8352Z",
    fill: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M161.552 0L86.8792 39.3322H161.552V0Z",
    fill: "#6C757D"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M161.552 0L86.8792 39.3322H161.552V0Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M161.552 39.3322L105.096 29.739L161.552 0V39.3322Z",
    fill: "black"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M155.847 20.8369H148.926C148.31 20.8369 147.812 21.3357 147.812 21.951V24.0346C147.812 24.6499 148.31 25.1487 148.926 25.1487H155.847C156.462 25.1487 156.961 24.6499 156.961 24.0346V21.951C156.961 21.3357 156.462 20.8369 155.847 20.8369Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M155.858 29.3367H139.353C139.058 29.3367 138.774 29.2194 138.565 29.0104C138.356 28.8015 138.239 28.5182 138.239 28.2227C138.239 27.9272 138.356 27.6439 138.565 27.4349C138.774 27.226 139.058 27.1086 139.353 27.1086H155.858C156.151 27.1114 156.432 27.2299 156.639 27.4386C156.845 27.6472 156.961 27.929 156.961 28.2227C156.961 28.5164 156.845 28.7982 156.639 29.0068C156.432 29.2154 156.151 29.334 155.858 29.3367Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M154.465 39.3323L137.692 53.7634V39.3323H154.465Z",
    fill: "black"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M149.782 64.6975L154.465 220.531H149.782V64.6975Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoActiveSessions);
export default __webpack_public_path__ + "static/media/no-active-sessions.31dbc5f64fdae84f8c4e06f25b93e1c5.svg";
export { ForwardRef as ReactComponent };